var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.73626 0.41916L3.9996 2.68249L6.26293 0.41916C6.49043 0.19166 6.85793 0.19166 7.08543 0.41916C7.31293 0.64666 7.31293 1.01416 7.08543 1.24166L4.40793 3.91916C4.18043 4.14666 3.81293 4.14666 3.58543 3.91916L0.90793 1.24166C0.68043 1.01416 0.68043 0.64666 0.90793 0.41916C1.13543 0.197493 1.50876 0.19166 1.73626 0.41916Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.5d230409fdb8591d65246fa79534b51d.svg";
export { ForwardRef as ReactComponent };